import { makeVar } from '@apollo/client'
import { UserBlockchainBalance } from '__generated__/graphql'

export const initialUserBlockChainBalance: UserBlockchainBalance = {
  walletAddress: '',
  nativeBalance: 0,
  tokenBalance: 0,
  tokenDeposited: 0,
  chainIdentifier: ''
}

/** Balances of every wallet linked to the user, keyed by wallet address. */
export const walletBalancesVar = makeVar<Record<string, UserBlockchainBalance>>(
  {}
)

/** Balance of the wallet selected for play. */
export const balanceVar = makeVar<UserBlockchainBalance>(
  initialUserBlockChainBalance
)
